import React from 'react';
import { Typography } from '../../index';

interface IDrawerContentProps {
	title?: string;
	content: React.ReactNode;
}

export const DrawerContent = ({ title, content }: IDrawerContentProps) => {
	return (
		<>
			{title && (
				<Typography className="font-normal py-6 md:py-8" component="h3" color="title" size="h2">
					{title}
				</Typography>
			)}
			<div className="flex flex-col gap-4">
				<Typography color="text" size="xlSpace">
					{content}
				</Typography>
			</div>
		</>
	);
};
